<template>
  <div>
    <span class="uk-label uk-background-secondary"><a class="uk-link-reset" :href="otherLanguageCode">{{ languages[otherLanguageCode] }}</a></span>
    <div class="uk-section">
      <div class="intro">
        <div class="uk-card uk-card-default uk-card-body uk-margin-left">
          <p>{{ $t("intro.funnyGame") }}</p>
          <p>{{ $t("intro.itIsLikePairs")}} ...</p>
        </div>
        <div class="uk-card uk-card-default uk-card-body uk-margin-left">
          <pairAnimation></pairAnimation>
        </div>
        <div class="uk-card uk-card-default uk-card-body uk-margin-left">
          <p>🔊 ... {{ $t("intro.switchOnTheSound") }} ... 🔊</p>
          <p>{{ $t("intro.findThePairs") }}</p>
        </div>
      </div>
    </div>
    <h1 class="uk-margin-remove-top">{{ $t("setup.players") }}</h1>
    <players></players>
    <div class="levels">
      <bird-level v-for="key in levelKeys" :levelKey="key"></bird-level>
    </div>
    <div class="uk-section" v-if="gameReady">
      <router-link :to="{path: '/play', query: query}" tag="button" @click="gameReady" class="uk-button uk-button-primary" id="play-button">Start</router-link>
    </div>
  </div>
</template>
<script>
  import Level from "./Level.vue"
  import PairAnimation from "./Animation.vue"
  import Players from "./PlayerLabels.vue"

  import { mapGetters } from "vuex"

  export default {
    data() {
      return {
        languages: { cz: "Česky", en: "English"}
      }
    },
    computed: {
      ...mapGetters(["players", "language", "levels", "selectedLevel"]),
      otherLanguageCode() {
        return this.language == "en" ? "cz" : "en";
      },
      levelKeys() {
        return Object.keys(this.levels);
      },
      gameReady() {
        return this.players.length > 0 && this.levels[this.selectedLevel].length > 3
      },
      query() {
        return { dev: this.$route.query.dev }
      }
    },
    components: {
      birdLevel: Level,
      pairAnimation: PairAnimation,
      players: Players
    }
  }
</script>

<style scoped>
  #play-button {
    margin: 1em;
  }
  .levels {
    display: flex;
  }
  .intro {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue